import Image from 'next/image';
import { useTranslations } from 'next-intl';

import {
  GIFT_CARD_PAYMENT_SYSTEM_CARD_UUID,
  GIFT_CARD_PAYMENT_SYSTEM_SBP_UUID
} from '@/api/backend/contract/Payment';
import { UiKitButton } from '@/ui-kit/button';

import { styles } from './GiftCardPayButtons.styles';

export interface GiftCardPayButtonsProps {
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

export function GiftCardPayButtons({
  disabled,
  loading,
  className
}: GiftCardPayButtonsProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base({ className })}>
      <UiKitButton
        type="submit"
        name="paymentSystemUuid"
        value={GIFT_CARD_PAYMENT_SYSTEM_SBP_UUID}
        disabled={disabled}
        loading={loading}
        className={slots.button()}
        childrenClassName={slots.sbpContent()}
      >
        {t('pay')}
        <Image
          src="/icons/payment-spb.svg"
          width={24}
          height={24}
          alt=""
        />
        <span className={slots.sbpLabel()}>{t('giftCard.paySbp')}</span>
      </UiKitButton>
      <UiKitButton
        type="submit"
        name="paymentSystemUuid"
        value={GIFT_CARD_PAYMENT_SYSTEM_CARD_UUID}
        color="transparent"
        disabled={disabled}
        loading={loading}
        className={slots.cardButton()}
      >
        {t('giftCard.payByCard')}
      </UiKitButton>
    </div>
  );
}
